"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _neptune = require("./neptune");

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require("./_n");

var _n3 = _interopRequireDefault(_n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.unique = {
  init: function init(p) {
    p = p || document;

    _neptune2.default.debug.info("unique:init", { el: p });

    _n3.default.qsa("[neptune-unique]", p).forEach(function (el) {

      var _unique = {};

      try {
        if (!!el.getAttribute("neptune-unique")) {
          _unique = USON.parse(el.getAttribute("neptune-unique").replace(/'/g, '"').replace(/`/g, "'").replace(/</g, "[").replace(/>/g, "]"), "array")[0];
        }
      } catch (error) {}

      var prop = 'innerText';
      var children = [].concat((0, _toConsumableArray3.default)(el.children));

      var vals = [];
      children.forEach(function (child) {
        if (vals.indexOf(child[prop]) > -1) child.remove();
        vals.push(child[prop]);
      });
    });
  }
};

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.debug;